<template>
	<side-window class="vehicle" title="Køretøjer" @pop="$emit('pop')" @close="$emit('close')">
		<div class="vehicle-item" v-for="vehicle in vehicles" :key="vehicle.id" @click="vehicleSelect(vehicle.id, vehicle.name)">
			<div class="label"><div :class="'status ' + (!vehicle.duration || vehicle.duration > (5 * 60) ? 'silent' : (vehicle.event ? (vehicle.event.event != 'stop' ? 'driving' : 'parked') : 'silent'))"></div>{{ vehicle.name }}</div>
			<div v-if="vehicle.event" class="alert">{{ ev[vehicle.event.event] }}, {{ vehicle.event.data }} <br> {{ vehicle.event.logged }}</div>
		</div>
	</side-window>
</template>

<script>
	import SideWindow from '../../components/SideWindow'
	import TrackingHistoryWindow from './TrackingHistoryWindow'
	//import Edit from '../../components/Edit'
	//import FormLine from '../../components/FormLine'
	//import FormGrid from '../../components/FormGrid'
	//import Button from '../../components/Button'
	//import Select from '../../components/Select'
	//import Switch from '../../components/Switch'
	//import ProfilePhoto from '../../components/ProfilePhoto'
	//import Tabs from '../../components/Tabs'
	//import Memo from '../../components/Memo'
	//import Entity from '../../components/Entity'

	export default {
		data: function () {
			return {
				vehicles: [],
				ev: {
					start: 'Kørt',
					stop: 'Stoppet',
					enter: 'Ankommet',
					leave: 'Forladt'
				}
			};
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		components: {
			sideWindow: SideWindow,
			//edit: Edit,
			//sel: Select,
			//formLine: FormLine,
			//formGrid: FormGrid,
			//btn: Button,
			//sw: Switch,
			//photo: ProfilePhoto,
			//tabs: Tabs,
			//memo: Memo,
			//ent: Entity
		},
		methods: {
			vehicleSelect(id, label) {
				

				this.$store.state.windowStack.push(TrackingHistoryWindow, {id: id, label: label, onChange: function () {
					//contacts.update();
					//
				}});
			}
		},
		mounted: function() {
			
			

			var win = this;

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					win.vehicles = r.data._items;
				});
		}
	}
</script>

<style lang="scss" scoped>
	.vehicle-item {
		padding: 20px 20px 20px 20px;
		border-bottom: 1px solid #333;
		cursor: pointer;
	}

	.vehicle-item > .label {
		padding-left: 20px;
		position: relative;
	}

	.vehicle-item > .label > .status {
		position: absolute;
		left: 0;
		top: 5px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
	}

	.vehicle-item > .label > .driving {
		background-color: green;
	}

	.vehicle-item > .label > .parked {
		background-color: blue;
	}

	.vehicle-item > .label > .silent {
		background-color: red;
	}

	.vehicle-item > .alert {
		padding-top: 5px;
		font-size: 14px;
		color: rgb(121, 121, 121);
	}
</style>
